/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-08-08 11:57:10
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-11-18 13:38:25
 */
import { API_URL } from '@/api/url';
import { Http } from '@/lib/http';

export class CommonApi {
  /**
   * 获取用户权限
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/768556
   */
  static getUserAuth = () => {
    return Http({
      allRes: true, // 返回完整response
      method: 'GET',
      url: API_URL.GetUserAuth
    });
  };

  /**
   * 获取筛选条件下拉框
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/768559
   */
  static getFilterList = () => {
    return Http<any>({
      method: 'GET',
      url: API_URL.GetFilterList
    });
  };

  /**
   * 获取客服帮助中心url
   *
   */
  static getCsUrl = () => {
    return Http<{
      cx_jump_link: string;
    }>({
      method: 'GET',
      url: API_URL.GetCsUrl,
      errorToast: false
    });
  };
}

export default CommonApi;
